module.exports = __webpack_public_path__ + "static/media/IMG_6534 (1) 1.c487a939.jpg";